import { mapGetters } from 'vuex'
import { some, isEmpty } from 'lodash-es'
import VariationListingFiltersModel from '../Models/VariationListingFiltersModel'

export default {
  data: () => {
    return {
      variationListingFiltersModel: null
    }
  },
  created () {
    const duplicateVariationGroupNamesPerGroup = this.getVariationMergeDuplicateValuesByName ? this.getDuplicateVariationGroupNamesPerGroup : {}
    this.variationListingFiltersModel = new VariationListingFiltersModel(
      this.getUriWithoutOffset,
      this.getVariationFilterQueryStringVar,
      this.getActiveVariationFilters,
      this.getIsTopLevelCategory,
      this.getCurrentPageNumber,
      this.config.url.lang,
      this.activeFiltersString,
      duplicateVariationGroupNamesPerGroup
    )
  },
  computed: {
    ...mapGetters([
      'getVariationFilterQueryStringVar',
      'getActiveVariationFilters',
      'getVariationRecordsUsed',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveAttributeFiltersString',
      'config',
      'getDuplicateVariationGroupNamesPerGroup',
      'getVariationMergeDuplicateValuesByName',
      'getActiveTagFiltersString'
    ]),
    activeFiltersString () {
      const tagFiltersString = this.getActiveTagFiltersString
      const attributeFiltersString = this.getActiveAttributeFiltersString
      if (tagFiltersString !== '' && attributeFiltersString !== '') {
        return tagFiltersString + '&' + attributeFiltersString
      }
      if (tagFiltersString !== '') {
        return tagFiltersString
      }
      if (attributeFiltersString !== '') {
        return attributeFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringLocationManage (group, entry) {
      window.location.assign(this.filteringManage(group, entry))
    },
    filteringManage (group, entry) {
      const isFilterUsed = this.isFilterUsed(group, entry)
      return this.variationListingFiltersModel.createLinkQueryStringFinal(group, entry, isFilterUsed)
    },
    checkIfAllVariationValueIdsAreUsed (group, entry) {
      const entryIds = entry.chunkValueIds
      if (!isEmpty(this.getVariationRecordsUsed[group.variationGroupId])) {
        const variationRecordKeysUsed = Object.keys(this.getVariationRecordsUsed[group.variationGroupId]).map(Number)
        return entryIds.map(
          (key) => {
            return variationRecordKeysUsed.includes(key)
          }
        ).every(element => element === true)
      }
      return false
    },
    isFilterUsed (group, entry) {
      if (this.isTextRangeGroup(group)) {
        return this.checkIfAllVariationValueIdsAreUsed(group, entry)
      } else {
        return some(this.getVariationRecordsUsed[group.variationGroupId], { variationId: entry.variationId })
      }
    },
    isTextRangeGroup (group) {
      return this.variationListingFiltersModel.isTextRangeGroup(group)
    },
    entryDisplayValue (group, entry, { trim = false, trimLength = 30 } = {}) {
      if (this.isTextRangeGroup(group)) {
        return entry.chunkName
      }
      if (group.variationDisplayType === 'image' || group.variationDisplayType === 'hex-color') {
        return entry.variationDisplayValue
      }
      if (trim) {
        return entry.variationName.length > trimLength ? entry.variationName.substring(0, trimLength) + '...' : entry.variationName
      }
      return entry.variationName
    }
  }
}
